import { SHOW_TAB, SHOW_LOADER, SHOW_MOBILE } from 'fixtures/actions'

const initialState = { isShowTab: true, isMobileView: false };

export const viewState = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TAB:
      return { ...state, isShowTab: action.payload };
    case SHOW_LOADER:
      return { ...state, isLoading: action.payload };
    case SHOW_MOBILE:
      return { ...state, isMobileView: action.payload };
    default:
      return state;
  }
}